import React, { useEffect } from 'react';
import AOS from 'aos';
import AboutSection from './AboutSection';
import HomeProjects from './HomeProjects';
import HoverRevealBox from './HoverRevealBox';

export default function HomeSection() {
  
  useEffect(() => {
    AOS.refresh();
  }, []);
  return (
    <>
    
<section className='page-container' >
   
   <AboutSection mtop='-2' />
    <h3 className='mt-3 mb-5 w-100 pt-5'>Our Number Don’t Lie.</h3>
    <div id='home-stats'>
    
      <div className='stats'>
        <div className='item' data-aos="fade-down" data-aos-delay="200">
          <label>Founded</label>
          <p>2020</p>
        </div>      
        
        <div className='item' data-aos="fade-up" data-aos-delay="200">
          <label>Project value completed</label>
          <p>R85m+</p>
        </div>
       
      </div>
    </div>
     
    
    {/* <div id='home-values' className='W-100 mb-4'>
    <h3 className='mt-3 mb-5 w-100 bg-img'>Our Core Values.</h3>     
    <h4 data-aos="fade-right" >Care, Trust, Delivery, Agility,<br/>
          Team Work and Sustainability.</h4>
      
    </div> */} 
    <div id='home-values' className=''>
      <div className="abs-bg bg-img"></div>
        <h3 className='mb-4'>Our Core Values.</h3>
        <h4 className='text-left' data-aos="fade-right" >
          Care, Trust, Delivery, Agility,<br/>
          Team Work and Sustainability.
        </h4>
    
    </div>
    <div id='home-mission' className='bg-img'>
      <div className="abs-bg-shadow"></div>
      <div className='description-grid'>
        <h3 data-aos="fade-right" data-aos-delay="00">Our mission.</h3>
        <p className='description ' data-aos="fade-left" data-aos-delay="00">
          Our aim is to diversify and
          grow in a sustainable way to<br/>
          become the leading building
          and infrastructure service<br/>
          group in Africa.<br/>
        </p>
      </div>
    </div>

    <h3 className='mt-5 mb-5 w-100 pt-5' data-aos="fade-right" >Affilations.</h3>
    <div id='home-affilations' className='img-boxes'>
     
      <div data-aos="fade-up">
        <HoverRevealBox
          label={'South Africa Institute of Civil Engineering'}
          imageSrc={`../assests/imgs/pexels-m&w-studios-193791.webp`}
          preview={true}
          forcePreview={false}
        />
      </div>
      <div data-aos="fade-up">
        <HoverRevealBox
          label={'South Africa Council of Quantity Surveying'}
          imageSrc={`../assests/imgs/warehouse-workers-wearing-yellow-helmets.webp`}
        />
      </div>
      <div data-aos="fade-up">
        <HoverRevealBox
          label={'South Africa Institute of for the Project and Construction Management Professions'}
          imageSrc={`../assests/imgs/pexels-emre-can-acer-2079622.webp`}          
        />
      </div>
      <div data-aos="fade-down">
        <HoverRevealBox
          label={'National Home Building Registration Board'}
          imageSrc={`../assests/imgs/pexels-david-yu-1872165.webp`}
        />
      </div>
      <div data-aos="fade-down">
        <HoverRevealBox
          label={'Construction Industry Development Board'}
          imageSrc={`../assests/imgs/warehouse-coworkers-managing-inventory (1).webp`}
          
        />
      </div>
      <div data-aos="fade-down">
        <HoverRevealBox
          label={'Engineering Council of Southern Africa'}
          imageSrc={`../assests/imgs/emmanuel-ikwuegbu--0-kl1BjvFc-unsplash.webp`}
          preview={true}
          forcePreview={false}
        />
      </div>
      
    </div>
    <h3 className='mt-5 mb-5 w-100 pt-5' data-aos="fade-right">Affiliate Logos.</h3>
    <div id='home-clients' className='text-center mb-4'>
      <img className='w-100 ' src={`../assests/imgs/Logos/Client Logos.png`} alt='logos'/>

    </div>
    <h3 className='mt-5 mb-5 w-100 pt-5' data-aos="fade-right">Clients.</h3>
    <div id='home-clients' className='text-center mb-4 p-'>
      <img src={`../assests/imgs/Logos/Client Logos@3x.png`} alt='logos'/>

    </div>
    <div id='home-projects-container'>
      <HomeProjects></HomeProjects>
    </div>

</section>
    </>
  )
}
